import React from 'react';
import PageHeader from "../../components/PageHeader";
import { customTableStyles } from "../../utils";
import DataTable from "react-data-table-component";
import { Button } from "react-bootstrap";

const ImportLeadPage = () => {
    const columns = [
        {
            name: 'Action',
            cell: (row, i) => {
                return (
                    <>
                        <div className="hstack gap-1 fs-1">
                            <a
                                aria-label="anchor"
                                href="javascript:void(0);"
                                className="btn btn-icon btn-sm btn-danger-light btn-wave waves-effect waves-light"
                            >
                                <i className="ri-delete-bin-7-line" />
                            </a>
                        </div>
                    </>
                )
            },
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
        {
            name: 'Full Name',
            selector: row => row.name,
            sortable: true,
        },
        {
            name: 'Email',
            selector: row => row.email,
            sortable: true,
        },
        {
            name: 'Mobile',
            selector: row => row.mobile,
            sortable: true,
        },
        {
            name: 'City',
            selector: row => row.city,
            sortable: true,
        },
        {
            name: 'Country',
            selector: row => row.country,
            sortable: true,
        },

    ];

    const data = [
        {
            id: 1,
            name: 'Beetlejuice',
            email: 'sha@gmail.com',
            mobile: '+923133455',
            city: 'karachi',
            country: 'pakistan',
        },
        {
            id: 1,
            name: 'Beetlejuice',
            email: 'sha@gmail.com',
            mobile: '+923133455',
            city: 'karachi',
            country: 'pakistan',
        },
    ]
    return (
        <>
            <PageHeader name="Import Lead" />

            <div className="row">
                <div className="col-xl-12">
                    <div className="card custom-card">
                        <div className="card-body">
                            <form className="row align-items-end">
                                <div className="col">
                                    <label className="form-label s-14">Csv File &nbsp;</label>
                                    <input
                                        className="form-control" type="file" name="file"
                                        accept=".csv, application/vnd.openxmlformats-off icedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                    />
                                </div>
                                <div className="col-lg-auto col-auto">
                                    <button className="btn btn-primary text-white w-100" type="submit">
                                        Upload Csv
                                    </button>
                                </div>
                            </form>
                            <div  className='mt-2'>
                                <a href="/example.csv" download target='_blank'>Download Sample File</a>
                            </div>
                        </div>
                    </div>

                    <div className="card custom-card">
                        <div className="card-body">
                            <DataTable
                                columns={columns}
                                data={data}
                                customStyles={customTableStyles}
                            />
                        </div>
                    </div>

                    <div className="card custom-card">
                        <div className="card-body">
                            <Button variant="primary" className="text-white w-100">
                                Upload
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ImportLeadPage;